import axios from 'axios';

import React, { FC, useEffect, useState } from 'react';
import TableComponent from '../../components/TableComponent';

import Header from '../../layout/Header';
import Footer from '../../layout/Footer';

import { IProdutos } from './interfaces';
import { ProdutosDiv } from './styles';

// Interna
const Produtos: FC<IProdutos> = () => {

  const [ data, setData ] = useState<any>({});

  // use effect
  useEffect(() => {
    const load = async () => {
      await axios.get(`data/products-info-pt.json`)
        .then(res => setData(res.data))
        .catch(err => console.log(err))
    };

    load();
  }, []);

  // render
  return (
    <ProdutosDiv>
      <Header/>

      <TableComponent/>

      <Footer/>
    </ProdutosDiv>
  );
};

export default Produtos;